import { combineReducers } from "redux";
import IndicesQuoteOverviewReducer from "./reducer/IndicesOverview";
export default combineReducers({ IndicesQuoteOverviewReducer });
